import React, { useState } from "react";
import { Image, Button } from "react-bootstrap";
import moment from "moment";
import CallingButtonPopup from "../../allPopupReusable/CallingButtonPopup";
import SendSmsButton from "../../allPopupReusable/SendSmsButton";
import NotificationButton from "../../allPopupReusable/NotificationButton";
// import { PopupIconButtonReusable } from "../../allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
// import ViewButtonPopup from "../../allPopupReusable/ViewButtonPopup";
// import EditDiner from "../../allPopupReusable/editDinerAndEditReservaion/EditDiner";
import DeletePopup from "../../allPopupReusable/smallPopup/DeletePopup";
import LocationReusable from "../../allPopupReusable/locationReusablePopup/LocationReusable";
import ViewDiner from "../../../vendorDashboardComponents/seatingDashboard/ViewDiner";
import EditDiner from "../../../vendorDashboardComponents/seatingDashboard/EditDiner";
import ChatWindow from "../../../vendorDashboardComponents/seatingDashboard/seatingDashboard/ChatWindow";
import CallingIconButtonActionFile from "../../allPopupReusable/tableNumberPopup/CallingIconButtonAction/CallingIconButtonActionFile";

export const HistoryDashboardBody = (props) => {
  const currentTime = new Date();
  var endTime = moment(currentTime).format("YYYY-MM-DDTHH:mm");
  const createdAt = new Date(props.dinerInfo.createdAt);
  var startTime = moment(createdAt).format("YYYY-MM-DDTHH:mm");

  let dateOne = new Date(startTime);
  let dateTwo = new Date(endTime);

  let msDifference = dateTwo - dateOne;
  let minutes = Math.floor(msDifference / 1000 / 60);

  function time_convert(minutes) {
    var hours = Math.floor(minutes / 60);
    var nMinutes = minutes % 60;
    return hours + " HH : " + nMinutes + " min";
  }

  const updatedTime = new Date(
    props?.dinerInfo?.wait_time !== undefined
      ? props?.dinerInfo?.wait_time_date
      : props?.dinerInfo?.reservationTime
  );
  const currentTimeTwo = new Date().getTime();
  const updatedTimeNew = updatedTime.getTime();
  const waitTime =
    props?.dinerInfo?.wait_time !== undefined
      ? props?.dinerInfo?.wait_time * 60 * 1000
      : 0;
  let updateWaitTime = updatedTimeNew + waitTime;
  let diff = updateWaitTime - currentTimeTwo;

  const seatedTime = new Date(props.dinerInfo.seatedTime);
  const updatedAt = new Date(props.dinerInfo.updatedAt);
  var endSeatedTime = moment(seatedTime).format("YYYY-MM-DDTHH:mm");
  var startTimeNew = moment(createdAt).format("YYYY-MM-DDTHH:mm");
  // var updatedTimeNew = moment(updatedAt).format("YYYY-MM-DDTHH:mm");
  let dateOneSeated = new Date(startTimeNew);
  let dateTwoSeated = new Date(endSeatedTime);
  let dataThreeSeated = new Date(updatedTimeNew);

  let msDifferenceSeated = dateTwoSeated - dateOneSeated;
  let totalUpdatedTime = dataThreeSeated - dateOneSeated;
  let minutesSeated = Math.floor(msDifferenceSeated / 1000 / 60);
  let minutesUpdatedTime = Math.floor(totalUpdatedTime / 1000 / 60);

  function seated_time_difference(minutesSeated) {
    var hours = Math.floor(minutesSeated / 60);
    var nMinutesSeated = minutesSeated % 60;
    return hours + " HH : " + nMinutesSeated + " min";
  }

  function upated_time_difference(minutesUpdatedTime) {
    var hours = Math.floor(minutesUpdatedTime / 60);
    var nMinutesUpdatedTime = minutesUpdatedTime % 60;
    return hours + " HH : " + nMinutesUpdatedTime + " min";
  }

  // var date1 = new Date();
  // var date2 = new Date(props.dinerInfo.createdAt);

  const [TrDetail, setTrDetail] = useState({ TrDetail: false });
  const showTr = () => setTrDetail({ TrDetail: !TrDetail.TrDetail });

  let vendorId = JSON.parse(localStorage.getItem("vendorId"));
  let subscriptionId = JSON.parse(localStorage.getItem("subscriptionId"));

  const [editWaitTimeModel, seteditWaitTimeModel] = useState(false);
  const changeEditWaitTimeModel = () => seteditWaitTimeModel(false);
  const openEditWaitTimeModel = () => seteditWaitTimeModel(true);

  return (
    <React.Fragment>
      <tbody className="w-100 seating-dashboard-body-new">
        <tr className="w-100 p-0">
          <td className="p-0 w-100">
            <table className="w-100">
              <tbody className="sd_body_css">
                <tr
                  className={`cursor sd_body_tr ${
                    props.dinerInfo.service_type === "RESERVATION"
                      ? "td_b_o"
                      : "td_b_g"
                  }`}
                  onClick={showTr}
                >
                  <td
                    className={
                      props.dinerInfo.isWalkIn === true ||
                      props.dinerInfo.isWalkIn === false
                        ? "td_b_g order-type-Image"
                        : "td_b_o order-type-Image"
                    }
                    style={{ width: "6%" }}
                  >
                    {props.dinerInfo.isWalkIn === true &&
                    props.dinerInfo.service_type === "SEATING" ? (
                      <Image
                        src={require("../../../../assets/images/ActionImages/image/walkin.svg")}
                        alt="Order Type"
                        title="Order Type"
                      />
                    ) : null ||
                      (props.dinerInfo.isWalkIn === false &&
                        props.dinerInfo.service_type === "SEATING") ? (
                      <Image
                        src={require("../../../../assets/images/ActionImages/image/waitlist.svg")}
                        alt="Order Type"
                        title="Order Type"
                      />
                    ) : null ||
                      props.dinerInfo.service_type === "RESERVATION" ? (
                      <Image
                        src={require("../../../../assets/images/ActionImages/image/reservation.svg")}
                        alt="Order Type"
                        title="Order Type"
                      />
                    ) : null}
                  </td>
                  <td style={{ width: "20%" }}>
                    <h4 className="font_20_m">{props.dinerName}</h4>
                    <p className="f9-500 my-1">#{props?.dinerInfo?.diner_id}</p>
                    {props.dinerInfo?.cross_ref_id !== null &&
                    props.dinerInfo?.cross_ref_id !== undefined ? (
                      <p className="f9-500">
                        #{props?.dinerInfo?.cross_ref_id?.order_id}
                      </p>
                    ) : null}
                  </td>
                  <td style={{ width: "15%" }}>
                    <div className="total-pax-body">
                      <div className="col d-flex p-0">
                        <div className="total-pax-body-inside">
                          <h4 className="font_24_b">
                            {props.dinerInfo.adult_count +
                              props.dinerInfo.kids_count}
                          </h4>
                          {/* <p className="total-pax-light-text">PAX</p> */}
                        </div>
                        <div className="total-adult-kids">
                          {props.dinerInfo.adult_count === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/adult.svg")}
                                alt="Adult"
                                title="Adult"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {props.dinerInfo.adult_count}
                              </p>
                            </div>
                          )}
                          {props.dinerInfo.kids_count === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/kids.svg")}
                                alt="Kids"
                                title="Kids"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {props.dinerInfo.kids_count}
                              </p>
                            </div>
                          )}
                        </div>
                        <div className="total-highchair-handicapp">
                          {props.dinerInfo.high_chair === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/highchair.svg")}
                                alt="Highchair"
                                title="Highchair"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {props.dinerInfo.high_chair}
                              </p>
                            </div>
                          )}
                          {props.dinerInfo.handicap_chair === 0 ? null : (
                            <div className="display-align">
                              <Image
                                src={require("../../../../assets/images/ActionImages/image/handicap.svg")}
                                alt="Handicapped"
                                title="Handicapped"
                                className="pax-type-Image"
                              />
                              <p className="font_12_m ml-1 mr-1">
                                {props.dinerInfo.handicap_chair}
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ width: "15%" }}>
                    {/* <div className="date-time-timer-body">
                      <div className="time-and-edit-button">
                        <div className="timer-section mr-2">
                          <h4 className="timer-count">
                            <NewCountDown waitNew={diff} />
                          </h4>
                        </div>
                        <EditWaitTime allDataProps={props.dinerInfo._id} />
                      </div>
                    </div> */}
                    {/* <h4 className="font_20_m mb-3">
                      {props.dinerInfo.diner_status}
                    </h4> */}
                    <p className="font_20_r">
                      {props.dinerInfo.service_type === "RESERVATION"
                        ? moment(props.dinerInfo.reservationTime).format(
                            "Do MMM YYYY"
                          )
                        : moment(props.dinerInfo.createdAt).format(
                            "Do MMM YYYY"
                          )}
                    </p>
                    <p className="font_20_r">
                      {props.dinerInfo.service_type === "RESERVATION"
                        ? moment(props.dinerInfo.reservationTime).format(
                            "hh:mm A"
                          )
                        : moment(props.dinerInfo.createdAt).format("hh:mm A")}
                    </p>
                  </td>
                  <td style={{ width: "15%" }}>
                    <h4 className="font_20_m">
                      {props.dinerInfo.seating_preference[0]}
                    </h4>
                  </td>
                  <td style={{ width: "15%" }}>
                    <h4 className="font_20_m">
                      {props.dinerInfo.diner_status === "SEATED" ||
                      props.dinerInfo.diner_status === "COMPLETED"
                        ? seated_time_difference(minutesSeated)
                        : upated_time_difference(minutesUpdatedTime)}
                    </h4>
                  </td>
                  <td style={{ width: "32%" }}>
                    <div
                      className={
                        props.displayInfo === "SUPERADMIN"
                          ? "action-section-body justify-content-center"
                          : "row action-section-body align-items-center f10-500"
                      }
                      // action-section-body
                    >
                      {props.displayInfo === "SUPERADMIN" ? (
                        ""
                      ) : (
                        <div className="col-2 p-0 text-center">
                          {props.dinerInfo.diner_status === "COMPLETED" ||
                          props.dinerInfo.diner_status === "REJECTED" ? (
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="historyReset"
                              buttonText="Reset"
                              bigText="Request Reset"
                              reasonText="Are you sure to Reset ?"
                              dataSend={props.dinerInfo}
                              actionBy={props.actionPerformBy}
                              pathAction="HISTORY"
                              adminSendVendorId={vendorId}
                              IconButton={require("../../../../assets/images/iconButton/resetred.svg")}
                            />
                          ) : null ||
                            props.dinerInfo.diner_status === "SEATED" ? (
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="historyUnseated"
                              buttonText="Unseat"
                              bigText="Request Unseat"
                              reasonText="Are you sure to Unseat ?"
                              dataSend={props.dinerInfo}
                              actionBy={props.actionPerformBy}
                              pathAction="HISTORY"
                              adminSendVendorId={vendorId}
                              IconButton={require("../../../../assets/images/iconButton/backarrowred.svg")}
                            />
                          ) : null}
                        </div>
                      )}
                      <div className="middle-timer m-0 col-7 d-flex justify-content-center">
                        {/* <p className="font_12_r mb-2">Total Wait time</p> */}
                        <div
                          className="seating-status"
                          style={{
                            backgroundColor: `${
                              props.dinerInfo.diner_status === "SEATED"
                                ? "#E6FFDF"
                                : props.dinerInfo.diner_status === "COMPLETED"
                                ? "#D0FFB5"
                                : "#FFDFDF"
                            }`,
                          }}
                        >
                          {/* <i
                            className="fa fa-hourglass-half mr-3"
                            aria-hidden="true"
                          ></i> */}
                          <p
                            className="font_16_m"
                            style={{
                              color: `${
                                props.dinerInfo.diner_status === "SEATED"
                                  ? "#37AC1E"
                                  : props.dinerInfo.diner_status === "COMPLETED"
                                  ? "#198D00"
                                  : "#EE3A23"
                              }`,
                            }}
                          >
                            {/* {props.dinerInfo.diner_status === "SEATED" ||
                            props.dinerInfo.diner_status === "COMPLETED"
                              ? seated_time_difference(minutesSeated)
                              : upated_time_difference(minutesUpdatedTime)} */}
                            {props.dinerInfo.diner_status === "SEATED"
                              ? "SEATED"
                              : props.dinerInfo.diner_status === "COMPLETED"
                              ? "COMPLETED"
                              : props.dinerInfo.diner_status === "CANCELLED"
                              ? "CANCELLED"
                              : props.dinerInfo.diner_status === "REJECTED"
                              ? "REJECTED"
                              : ""}
                            {/* 00 <span>hh</span> : 20 <span>mins</span> */}
                          </p>
                        </div>
                        {/* <p className="font_16_r">
                          Status:&nbsp;
                          <span className="font_16_b">
                            {props.dinerInfo.diner_status === "SEATED"
                              ? "SEATED"
                              : props.dinerInfo.diner_status === "COMPLETED"
                              ? "COMPLETED"
                              : props.dinerInfo.diner_status === "CANCELLED"
                              ? "CANCELLED"
                              : props.dinerInfo.diner_status === "REJECTED"
                              ? "REJECTED"
                              : ""}
                          </span>
                        </p> */}
                      </div>
                      {props.displayInfo === "SUPERADMIN" ? (
                        ""
                      ) : (
                        <div className="col-2 p-0 text-center">
                          {props.dinerInfo.diner_status === "SEATED" ? (
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="historyCompleted"
                              buttonText="Complete"
                              bigText="Request Complete"
                              reasonText="Are you sure to Completed ?"
                              dataSend={props.dinerInfo}
                              actionBy={props.actionPerformBy}
                              pathAction="HISTORY"
                              adminSendVendorId={vendorId}
                              IconButton={require("../../../../assets/images/iconButton/Nextarrowgreen.svg")}
                            />
                          ) : null}
                        </div>
                      )}
                    </div>
                    {/* <div
                      className={
                        props.displayButton === true
                          ? "action-section-body d-flex align-items-center justify-content-center"
                          : "action-section-body align-items-center"
                      }
                    >
                      {props.dinerInfo.diner_status === "SEATED" ? (
                        <div>
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="seatingUnseated"
                            buttonText="Unseat"
                            bigText="Are you sure to Unseat ?"
                            dataSend={props.dinerInfo}
                          />
                        </div>
                      ) : (
                        <div>
                          <DeletePopup
                            buttonDisplay="smallCancelButton"
                            displayPopup="resonFforCancellation"
                            actionCall={"seatingDashboardSide"}
                            buttonText="Cancel"
                            bigText="Are you sure to Cancel ?"
                            dataSend={props.dinerInfo._id}
                          />
                        </div>
                      )}
                      <div className="middle-timer">
                        <p className="font_12_r">Total Wait time</p>
                        <div className="count-down-timer d-flex">
                          <i
                            className="fa fa-hourglass-half mr-3"
                            aria-hidden="true"
                          ></i>
                          <p className="font_16_m">
                            {props.dinerInfo.diner_status === "SEATED" ||
                            props.dinerInfo.diner_status === "COMPLETED"
                              ? seated_time_difference(minutesSeated)
                              : upated_time_difference(minutesUpdatedTime)}
                          </p>
                        </div>
                        <p className="font_20_r">
                          Status:&nbsp;
                          <span className="font_20_b">
                            {props.dinerInfo.diner_status === "NOTSEATED"
                              ? "NOT SEATED"
                              : "SEATED"}
                          </span>
                        </p>
                      </div>
                      {props.dinerInfo.diner_status === "SEATED" ? (
                        <div>
                          <DeletePopup
                            buttonDisplay="smallSaveButton"
                            displayPopup="seatingCompleted"
                            buttonText="Complete"
                            bigText="Are you sure to Completed ?"
                            dataSend={props.dinerInfo}
                          />
                        </div>
                      ) : (
                        <div>
                          <DeletePopup
                            buttonDisplay="smallSaveButton"
                            displayPopup="SeatedButton"
                            buttonText="Seat"
                            bigText="Are you sure to Seated ?"
                            dataSend={props.dinerInfo._id}
                          />
                        </div>
                      )}
                    </div> */}
                  </td>
                </tr>
                {TrDetail.TrDetail && (
                  <tr className="sd_accordion_body">
                    <td className="sd_accordion_td_7">
                      <h4 className="font_20_m c_red">More details</h4>
                      <div className="d-flex justify-content-between mt-3 mr-3">
                        {props.displayCall === true ? (
                          // <CallingButtonPopup
                          //   buttonClass="smallButton"
                          //   sendData={props.dinerInfo}
                          // />
                          <CallingIconButtonActionFile
                            orderDetails={props.dinerInfo?.user_details}
                            actionType="conbinedName"
                          />
                        ) : null}
                        {props.displaySms === true ? (
                          <SendSmsButton
                            dataSend={props.dinerInfo}
                            buttonClass="smallButton"
                          />
                        ) : null}
                        {props.displayNotification === true ? (
                          <NotificationButton
                            buttonClass="smallButton"
                            dataSend={props.dinerInfo}
                          />
                        ) : null}
                        {props.displayChat === true ? (
                          <ChatWindow
                            data={props.dinerInfo}
                            text={props.actionBy}
                          />
                        ) : null}

                        {props.displayViewDiner === true ? (
                          // <ViewButtonPopup
                          //   dataSend={props.dinerInfo}
                          //   buttonClass="smallButton"
                          // />
                          <ViewDiner
                            dataSend={props.dinerInfo}
                            displayData={props.displayInfo}
                            displayButton="HISTORY"
                            viewActionPerformBy={props.actionPerformBy}
                            viewVendorId={vendorId}
                            subscription_id={
                              props.actionPerformBy === "ADMIN"
                                ? subscriptionId
                                : props.subscription_id
                            }
                            socket={props.socket}
                            diff={diff}
                            displayEdit={true}
                            actionByData={"seating"}
                            auth={props.auth.user?.VendorUser?.role}
                            // changeEditWaitTimeModel={changeEditWaitTimeModel}
                          />
                        ) : null}
                        {props.displayEditDiner === true ? (
                          <EditDiner
                            buttonClass="smallButton"
                            dataSend={props.dinerInfo}
                            bigText="Edit Diner"
                            displayData={props.displayInfo}
                            displayButton="HISTORY"
                            viewActionPerformBy={props.actionPerformBy}
                            viewVendorId={vendorId}
                            subscription_id={
                              props.actionPerformBy === "ADMIN"
                                ? subscriptionId
                                : props.subscription_id
                            }
                          />
                        ) : null}
                      </div>
                    </td>
                    <td className="sd_accordion_td_2">
                      {props.auth.user?.VendorUser?.role !== "vendor" ? (
                        <></>
                      ) : (
                        <>
                          <h4 className="font_20_m">Track User Location</h4>
                          <LocationReusable
                            dataSend={props.dinerInfo}
                            disabled={true}
                          />
                        </>
                      )}
                    </td>
                    {/* <td className="sd_accordion_td_3">
                      <h4 className="font_20_m">Date & Time</h4>
                      <div className="mt-3">
                        <p className="font_16_r">
                          {props.dinerInfo.service_type === "RESERVATION"
                            ? moment(props.dinerInfo.reservationTime).format(
                                "Do MMM YYYY"
                              )
                            : moment(props.dinerInfo.createdAt).format(
                                "Do MMM YYYY"
                              )}
                        </p>
                        <p className="font_16_r">
                          {props.dinerInfo.service_type === "RESERVATION"
                            ? moment(props.dinerInfo.reservationTime).format(
                                "hh:mm A"
                              )
                            : moment(props.dinerInfo.createdAt).format(
                                "hh:mm A"
                              )}
                        </p>
                      </div>
                    </td> */}
                    <td className="sd_accordion_td_4">
                      <h4 className="font_20_m">Table / Room No.</h4>
                      <div className="mt-3">
                        <p className="font_16_r">
                          {props?.dinerInfo?.room_number === null ||
                          props?.dinerInfo?.room_number === undefined ||
                          props?.dinerInfo?.room_number === ""
                            ? ""
                            : `Room No. - ${props?.dinerInfo?.room_number}`}
                        </p>
                        <p className="font_16_r">
                          {props?.dinerInfo?.table_number === null ||
                          props?.dinerInfo?.table_number === undefined ||
                          props?.dinerInfo?.table_number === ""
                            ? ""
                            : `Table No. - ${props?.dinerInfo?.table_number}`}
                        </p>
                      </div>
                    </td>
                    <td
                      className="sd_accordion_td_5"
                      style={{ wordBreak: "break-word" }}
                    >
                      <h4 className="font_20_m">Special Occasion</h4>
                      <div className="d-flex mt-3">
                        <p
                          className="font_16_r"
                          style={{ wordBreak: "break-word" }}
                        >
                          {props.dinerInfo.occasion}
                          {/* {props.dinerInfo.occasion.length > 65 ? (
                            <span className="c_orange">&nbsp;see more</span>
                          ) : (
                            ""
                          )} */}
                        </p>
                      </div>
                    </td>
                    <td className="sd_accordion_td_8">
                      <h4 className="font_20_m">
                        Reason for{" "}
                        {`${
                          props.dinerInfo.diner_status === "REJECTED"
                            ? "rejection"
                            : "cancellation"
                        }`}
                      </h4>
                      <div className="d-flex mt-3">
                        <p className="font_16_m">
                          {props.dinerInfo.cancelReason}
                        </p>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
      {/* <div className="seating-dashboard-body">
        <div className="request-number-body">
          <div className="request-number-inside">
            <div className="d-flex">
              {sendDataDinerProps.isWalkIn === true &&
              sendDataDinerProps.service_type === "SEATING" ? (
                <Image
                  src={require("../../../../assets/images/ActionImages/walking-img.svg")}
                  alt="Order Type"
                  title="Order Type"
                  className="order-type-Image"
                />
              ) : null ||
                (sendDataDinerProps.isWalkIn === false &&
                  sendDataDinerProps.service_type === "SEATING") ? (
                <Image
                  src={require("../../../../assets/images/ActionImages/clock-circular-outline.svg")}
                  alt="Order Type"
                  title="Order Type"
                  className="order-type-Image"
                />
              ) : null || sendDataDinerProps.service_type === "RESERVATION" ? (
                <Image
                  src={require("../../../../assets/images/ActionImages/online-booking.svg")}
                  alt="Order Type"
                  title="Order Type"
                  className="order-type-Image"
                />
              ) : null}
              <div className="ml-2">
                <p
                  className={
                    sendDataDinerProps.service_type === "SEATING"
                      ? "big-text-yellow "
                      : null ||
                        sendDataDinerProps.service_type === "RESERVATION"
                      ? "big-text"
                      : null
                  }
                >
                  {dinerName}
                </p>
                <p className="small-text">{dinerRequestId}</p>
              </div>
            </div>
            <div className="col-12 request-number-display-icon">
              {displayCall === true ? (
                <CallingButtonPopup buttonClass="smallButton" />
              ) : null}
              {displaySms === true ? (
                <SendSmsButton
                  buttonClass="smallButton"
                  dataSend={sendDataDinerProps}
                />
              ) : null}
              {displayNotification === true ? (
                <NotificationButton
                  buttonClass="smallButton"
                  dataSend={sendDataDinerProps}
                />
              ) : null}
              {displayChat === true ? (
                <PopupIconButtonReusable
                  buttonClass={"smallButton"}
                  titleText="Send Sms Button"
                  image={require("../../../../assets/images/ActionImages/chat.png")}
                  // onClick={this.onOpenModal}
                />
              ) : null}
              {displayViewDiner === true ? (
                <ViewButtonPopup
                  buttonClass="smallButton"
                  dataSend={sendDataDinerProps}
                />
              ) : null}
              {displayEditDiner === true &&
              date2.getDate() < date1.getDate() ? (
                ""
              ) : (
                <EditDiner
                  buttonClass="smallButton"
                  bigText="Edit Diner"
                  dataSend={sendDataDinerProps}
                />
              )}
            </div>
          </div>
        </div>
        <div className="total-pax-body">
          <div className="col d-flex p-0">
            <div className="total-pax-body-inside">
              <p className="total-pax-value">{totalCount}</p>
              <p className="total-pax-light-text">PAX</p>
            </div>
            <div className="total-adult-kids">
              <div className="display-align">
                <Image
                  src={require("../../../../assets/images/ActionImages/employees.png")}
                  alt="Adult"
                  title="Adult"
                  className="pax-type-Image"
                />
                <p className="total-count">{totalAdult}</p>
              </div>
              <div className="display-align">
                <Image
                  src={require("../../../../assets/images/ActionImages/children.png")}
                  alt="Kids"
                  title="Kids"
                  className="pax-type-Image"
                />
                <p className="total-count">{totalKids}</p>
              </div>
            </div>
            <div className="total-highchair-handicapp">
              <div className="display-align">
                <Image
                  src={require("../../../../assets/images/ActionImages/highchair.png")}
                  alt="Highchair"
                  title="Highchair"
                  className="pax-type-Image-highchair"
                />
                <p className="total-count">{totalHighchair}</p>
              </div>
              <div className="display-align">
                <Image
                  src={require("../../../../assets/images/ActionImages/wheelchair.png")}
                  alt="Handicapped"
                  title="Handicapped"
                  className="pax-type-Image-handicapped"
                />
                <p className="total-count">{totalHandicapped}</p>
              </div>
            </div>
          </div>
        </div>
        <div className="location-body">
          <div className="location-inside-div">
            <div className="col-12">
              {/* <Image
                src={require("../../../../assets/images/ActionImages/maps-and-flagsred.png")}
                alt="location"
                title="location"
              /> *
              <LocationReusable dataSend={sendDataDinerProps} />
            </div>
            <p className="location-paragraph">{dinerStatus}</p>
          </div>
        </div>
        <div className="date-time-timer-body">
          <div className="date-time-timer-inside">
            {/* <div className="time-and-edit-button">
              <div className="timer-section">
                <h4 className="timer-count">12:15:22</h4>
                <p className="timer-hour-minute-second">HH: MM: SS</p>
              </div>
              <PopupIconButtonReusable
                buttonClass="smallButton"
                titleText="Send Sms Button"
                image={require("../../../../assets/images/ActionImages/newEdit.png")}
              />
            </div> *
            <p className="timer-time">
              {moment(sendDataDinerProps.createdAt).format("hh:mm A")}
            </p>
            <p className="timer-date">
              {moment(sendDataDinerProps.createdAt).format("Do MMM YYYY")}
            </p>
          </div>
        </div>
        <div className="seating-preference-body">
          <h4>{seatingPreference}</h4>
          <div className="d-flex">
            <h4>Room. {roomNumber}</h4>
          </div>
          <div className="d-flex">
            <h4>
              Table No. {tableNumber === null && undefined ? "" : tableNumber}
            </h4>
          </div>
        </div>
        <div className="special-occasion-body">
          <div id="style-4" className="special-occasion-body-inside">
            <p>{occasion}</p>
          </div>
        </div>
        <div
          className={
            displayRightButton === true
              ? "action-section-body"
              : "action-section-body-width"
          }
        >
          <div className="col-4 pl-0">
            {sendDataDinerProps.diner_status === "COMPLETED" ||
            sendDataDinerProps.diner_status === "REJECTED" ? (
              <DeletePopup
                buttonDisplay="smallCancelButton"
                displayPopup="historyReset"
                buttonText="Reset"
                bigText="Are you sure to Reset ?"
                dataSend={sendDataDinerProps}
              />
            ) : null || sendDataDinerProps.diner_status === "SEATED" ? (
              <DeletePopup
                buttonDisplay="smallCancelButton"
                displayPopup="historyUnseated"
                buttonText="UnSeat"
                bigText="Are you sure to UnSeat ?"
                dataSend={sendDataDinerProps}
              />
            ) : null}
          </div>
          <div className="col-4 p-0 middle-timer">
            <p className="total-wait-time">Total Wait time</p>
            <div className="count-down-timer">
              <p className="total-wait-time-hour">
                {dinerStatus === "SEATED" || dinerStatus === "COMPLETED"
                  ? seated_time_difference(minutesSeated)
                  : upated_time_difference(minutesUpdatedTime)}
                {/* 00 <span>hh</span> : 20 <span>mins</span> *
              </p>
            </div>
          </div>
          {sendDataDinerProps.diner_status === "SEATED" ? (
            <div className="col-4 pr-0">
              <DeletePopup
                buttonDisplay="smallSaveButton"
                displayPopup="historyCompleted"
                buttonText="Complete"
                bigText="Are you sure to Completed ?"
                dataSend={sendDataDinerProps}
              />
            </div>
          ) : null}
        </div>
      </div> */}
    </React.Fragment>
  );
};
